import { createEntityItemId, getRicosGalleryImages, getRicosImagesAltText, QUESTION_IMAGE_IDENTIFIER } from '@wix/a11y-rules';
import { StepType } from '@wix/ambassador-online-programs-v3-step/types';
export const extractCoverImagesFromPrograms = programs => {
  const imagesProgramsMap = {};
  programs.forEach(program => {
    var _settings$description;
    const {
      id,
      settings
    } = program;
    const image = settings == null || (_settings$description = settings.description) == null || (_settings$description = _settings$description.media) == null ? void 0 : _settings$description.image;
    if (!id) {
      return;
    }
    if (image != null && image.id) {
      const coverImageUniqueId = createEntityItemId([id ?? ''], (image == null ? void 0 : image.id) || '');
      imagesProgramsMap[coverImageUniqueId] = id;
    }
  });
  return {
    imagesProgramsMap,
    onlinePrograms: programs
  };
};
export const extractProfileImagesFromInstructors = instructors => {
  const imagesInstructorsMap = {};
  instructors.forEach(instructor => {
    const {
      photo
    } = instructor;
    if (!instructor.id) {
      return;
    }
    const coverImageUniqueId = createEntityItemId([instructor.id ?? ''], (photo == null ? void 0 : photo.id) || (photo == null ? void 0 : photo.url) || '');
    imagesInstructorsMap[coverImageUniqueId] = instructor.id;
  });
  return {
    imagesInstructorsMap,
    instructors
  };
};
export const extractImagesFromForms = forms => {
  const imageToQuizMap = {};
  forms.forEach(form => {
    const {
      id,
      fields
    } = form;
    fields == null || fields.forEach((field, questionIndex) => {
      const {
        view
      } = field;
      const questionImage = view == null ? void 0 : view.questionImage;
      if (questionImage) {
        const entityId = createEntityItemId([id ?? ''], questionImage.id, `${questionIndex}#${QUESTION_IMAGE_IDENTIFIER}`);
        imageToQuizMap[entityId] = id ?? '';
      }
      const fieldType = view == null ? void 0 : view.fieldType;
      if (fieldType === 'QUIZ_IMAGE_CHOICE') {
        var _field$view;
        const options = ((_field$view = field.view) == null ? void 0 : _field$view.options) ?? [];
        options.forEach((option, optionIndex) => {
          var _option$media;
          const image = (_option$media = option.media) == null ? void 0 : _option$media.image;
          if (image) {
            const entityId = createEntityItemId([id ?? ''], image.id, `${questionIndex}#${optionIndex}`);
            imageToQuizMap[entityId] = id ?? '';
          }
        });
      }
    });
  });
  return {
    imageToQuizMap,
    quizzes: forms
  };
};
export const extractImagesFromStepRico = (step, imagesToStepMap) => {
  const {
    id,
    description
  } = step;
  if (!id || !description || !description.details) {
    return;
  }
  const richContent = JSON.parse(description.details);
  const galleryImages = getRicosGalleryImages(richContent, id);
  const regularImages = getRicosImagesAltText(richContent, id);
  galleryImages.forEach(image => imagesToStepMap[image.id] = id);
  regularImages.forEach(image => imagesToStepMap[image.id] = id);
};
export const extractImagesFromSteps = steps => {
  const imagesToStepMap = {};
  const quizIdToStepId = {};
  steps.forEach(step => {
    var _step$quizOptions;
    switch (step.stepType) {
      case StepType.ARTICLE:
      case StepType.VIDEO:
        extractImagesFromStepRico(step, imagesToStepMap);
        break;
      case StepType.QUIZ:
        const quizId = (step == null || (_step$quizOptions = step.quizOptions) == null ? void 0 : _step$quizOptions.id) ?? '';
        quizIdToStepId[quizId] = step.id ?? '';
        break;
      default:
        break;
    }
  });
  const stepMap = new Map(steps.map(step => [step.id, step]));
  return {
    imagesToStepMap,
    quizIdToStepId,
    stepIdToStepMap: stepMap,
    steps
  };
};
//# sourceMappingURL=utils.js.map